
import { useRoute } from 'vue-router'
import { onMounted } from 'vue'
import globalVariables from '@/utils/globalVariables'
import { Toast } from 'vant'
import api from '@/api'
import { wxAuthorize, isInWxBrowser } from '@/utils/wechatUtil'

export default function useWechat(paramState) {
    const route = useRoute()

    let resState
    let { code, state } = route.query
    if (code) {
        resState  = decodeURIComponent(state)
    }

    onMounted(() => {
      if (isInWxBrowser()) {
          // 还没微信授权过，进行微信授权
        if (!globalVariables.getOpenid() && !code) {
          wxAuthorize(globalVariables.appId, paramState)
          return
        }
        // 通过微信授权后跳转回来
        if (!globalVariables.getOpenid() && code) {
          Toast.loading({
            duration: 0,
            forbidClick: true
          })
          api.fetchOpenid({ code }).then(res => {
            Toast.clear()

            if (res.error) {
              Toast.fail(res.error.message)
              return
            }
            globalVariables.setOpenid(res.data.openid)
          })
        }
      } else {
        Toast.fail('请在微信中打开, 否则部分功能无法使用哦')
      }
    })

    return {
        state: resState
    }
}